import { $, extend, classes } from '../core/core';
import { NavigationBase } from './navigation-base';
import { Widget } from './widget';

export const Navigation = function (elm, settings) {
    var $elm = $(elm),
        $menu,
        $widget,
        menuClass,
        s,
        widget,
        isList = $elm.is('ul,ol'),
        that = this;

    // Call the parent constructor
    NavigationBase.call(this, elm, settings, true);

    that._initMarkup = function () {
        if ($menu) {
            $menu.remove();
        }
        if ($widget) {
            $elm.append($widget.children());
        }
    };

    that.__size = function (contWidth, itemWidth) {
        var showMore,
            showMoreWidth = itemWidth || 72,
            itemsNr = that._$items.length,
            itemsWidth = 0;

        widget.hide();

        // show more menu
        if (s.type == 'bottom') {
            $elm.removeClass('mbsc-scv-liq'); //.empty(); // empty list
            $menu.remove();
            that._$items.remove().each(function (i) {
                var $item = $(this);
                $elm.append($item);
                itemsWidth += itemWidth || this.offsetWidth || 0;
                // if next item doesn't fit, add to show more menu
                if (Math.round(itemsWidth + (i < itemsNr - 1 ? showMoreWidth : 0)) > contWidth) {
                    showMore = true;
                    $widget.append($item.css('width', '').addClass('mbsc-fr-btn-e'));
                }
            });

            $menu
                .attr('class', menuClass + (s.moreIcon ? ' mbsc-menu-item-ic mbsc-ms-ic mbsc-ic mbsc-ic-' + s.moreIcon : ''))
                .html(that._hasIcons && that._hasText ? s.moreText : '');

            // add show more item if needed
            if (showMore) {
                $elm.append($menu);
            }
        }

        if (s.layout == 'liquid') {
            $elm.addClass('mbsc-scv-liq');
        }
    };

    that.__onItemTap = function ($item) {
        if ($item.hasClass('mbsc-menu-item') && that.trigger('onMenuShow', { target: $item[0], menu: widget }) !== false) {
            widget.show(false, true);
            return false;
        }
    };

    that.__getContClass = function () {
        return s.type == 'hamburger' ? ' mbsc-ms-hamburger' : '';
    };

    that.__markupReady = function ($cont) {
        if (s.type == 'hamburger') {
            $widget.append(that._$items.addClass('mbsc-fr-btn-e'));
            $menu
                .attr('class', menuClass + (s.menuIcon ? ' mbsc-menu-item-ic mbsc-ms-ic mbsc-ic mbsc-ic-' + s.menuIcon : ''))
                .html(s.menuText || '');

            $elm.append($menu);

            if (!s.menuText || !s.menuIcon) {
                $cont.removeClass('mbsc-ms-icons');
            }

            if (!s.menuText) {
                $cont.removeClass('mbsc-ms-txt');
            } else {
                $cont.addClass('mbsc-ms-txt');
            }
        }
    };

    that.___init = function () {
        var $target;

        if (s.type == 'tab') {
            s.display = s.display || 'top';
            s.variant = s.variant || 'b';
        } else if (s.type == 'bottom') {
            s.display = s.display || 'bottom';
            s.variant = s.variant || 'a';
        } else if (s.type == 'hamburger') {
            s.display = s.display || 'inline';
            s.variant = s.variant || 'a';
        }

        menuClass = 'mbsc-scv-item mbsc-ms-item mbsc-btn-e mbsc-menu-item ' + (s.itemClass || '');

        if (!$menu) {
            $menu = $(isList ? '<li></li>' : '<div></div>');
            $widget = $(isList ? '<ul></ul>' : '<div></div>').addClass('mbsc-scv mbsc-ms');
        }

        widget = new Widget($widget[0], {
            display: 'bubble',
            theme: s.theme,
            lang: s.lang,
            context: s.context,
            buttons: [],
            anchor: $menu,
            onBeforeShow: function (event, inst) {
                $target = null;
                inst.settings.cssClass = 'mbsc-wdg mbsc-ms-a mbsc-ms-more' + (that._hasText ? '' : ' mbsc-ms-more-icons');
            },
            onBeforeClose: function () {
                return that.trigger('onMenuHide', { target: $target && $target[0], menu: widget });
            },
            onMarkupReady: function (event, inst) {
                that.tap(inst._markup.find('.mbsc-fr-c'), function (ev) {
                    $target = $(ev.target).closest('.mbsc-ms-item');
                    if ($target.length && !$target.hasClass('mbsc-disabled')) {
                        that.navigate($target, true);
                        widget.hide();
                    }
                });
            }
        });
    };

    that.___destroy = function () {
        widget.destroy();

        $elm.append(that._$items);
        $menu.remove();
    };

    // ---
    // Constructor

    s = that.settings;
    that.init(settings);
};

// Defaults
Navigation.prototype = {
    _class: 'navigation',
    _hasDef: true,
    _hasTheme: true,
    _hasLang: true,
    _defaults: extend({}, NavigationBase.prototype._defaults, {
        type: 'bottom',
        moreText: 'More',
        moreIcon: 'material-more-horiz',
        menuIcon: 'material-menu'
    })
};

classes.Navigation = Navigation;



// WEBPACK FOOTER //
// ./src/js/lib/mobiscroll/classes/navigation.js